// Promise-based replacements for window.confirm() and window.alert().
//
//   if (!(await confirmDialog('Delete this lead?'))) return;
//   await alertDialog('Could not save.');
//
// The browser's own boxes are blocked or silently cancelled by some iPad and
// iPhone browsers (a blocked confirm() answers "no", so the action quietly
// never runs). These render an on-page dialog instead, through <DialogHost />
// mounted once at the app root. Callable from plain modules too (the session
// timer), because it is a tiny pub/sub rather than React context.
//
// If no host is mounted (unit tests, very early start-up) they fall back to
// the native boxes so nothing is lost.
const listeners = new Set();
let seq = 0;

export const subscribeDialogs = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const emit = (event) => listeners.forEach((fn) => fn(event));

const open = (kind, message, options = {}) => new Promise((resolve) => {
  if (listeners.size === 0) {
    if (kind === 'confirm') resolve(typeof window.confirm === 'function' ? !!window.confirm(message) : false);
    else { if (typeof window.alert === 'function') window.alert(message); resolve(true); }
    return;
  }
  seq += 1;
  emit({ type: 'open', dialog: { id: seq, kind, message: String(message ?? ''), ...options, resolve } });
});

// options: { title, confirmLabel, cancelLabel, danger }
export const confirmDialog = (message, options) => open('confirm', message, options);

// options: { title, okLabel, tone: 'error' | 'success' | 'info' }
export const alertDialog = (message, options) => open('alert', message, options);

// Dismiss everything on screen (used when the session ends). Pending
// confirms resolve false.
export const closeAllDialogs = () => emit({ type: 'closeAll' });
